import React from 'react';
import LevelTag from './LevelTag';

export type Level = 'organisation' | 'entity' | 'workspace' | 'platform';

export const LEVEL_LABELS: Record<Level, string> = {
  organisation: 'Organisation',
  entity: 'Entity',
  workspace: 'Workspace',
  platform: 'Platform'
};

interface LevelChipProps {
  level: Level;
  /** A smaller tag for dense rows (tables, breadcrumbs, menus). */
  compact?: boolean;
}

/** A level tag by kind. One style for every level; see `LevelTag`. */
const LevelChip: React.FC<LevelChipProps> = ({ level, compact }) => (
  <LevelTag
    label={LEVEL_LABELS[level]}
    level={level}
    className={compact ? 'sw-level-tag--compact' : undefined}
  />
);

export default LevelChip;
